import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import IconDelete from 'assets/icons/delete-icon.svg'
import { selectedBackupApproverGroupsVar, setHasUnsavedChanges } from 'cache/manage-backup'

type Props = {
  data?: any
}

const DeleteCellRenderer: React.FC<Props> = ({ data }) => {
  const onDelete = () => {
    if (!data?.id) return

    const id = data.id
    const current = selectedBackupApproverGroupsVar()

    let next

    if (data.isNewlyAdded) {
      next = current.filter((row: any) => row.id !== id)
    } else {
      next = current.map((row: any) => (row.id === id ? { ...row, isActive: false } : row))
    }

    selectedBackupApproverGroupsVar(next)
    setHasUnsavedChanges(true)
  }
  return (
    <Tooltip title="Remove assignment">
      <IconButton size="small" onClick={onDelete} color="error" data-testid="delete-row-btn">
        <img src={IconDelete} alt="Delete" style={{ width: '26px', height: '28px' }} />
      </IconButton>
    </Tooltip>
  )
}

export default DeleteCellRenderer
